import { shallow } from 'zustand/shallow'

/**
 * True while the Generate panel still holds exactly the settings the last run was
 * started with (see lockGenerationSettings). Any change to a model setting, the
 * generation action or the provider releases the lock; changing back re-engages it,
 * since that would resubmit the identical generation.
 * @param {Object} state - The 3D Studio store state
 * @returns {boolean}
 */
export const selectIsGenerationLocked = (state) => {
  const locked = state.generation.lockedGenerationSettings
  if (!locked) {
    return false
  }

  return locked.generationAction === state.schema.generationAction
    && locked.generationProvider === state.schema.generationProvider
    && shallow(locked.modelSettings, state.modelSettings)
}
